
define('app/purchases/paypal/paypalMain',[
	'domReady',
	'app/purchases/paypal/paypalApp',
	'app/common/setup'
], function(domReady, PaypalApp, Setup){
	domReady(function () {
		Setup.initialize();
		PaypalApp.initialize();
    });
});